// CustomRadioButton.js
import React from "react"
import styled from "styled-components"

const Wrapper = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  user-select: none;
`

const HiddenRadio = styled.input.attrs({ type: "radio" })`
  display: none;
`

const StyledRadio = styled.span<{ $checked: boolean }>`
  height: 16px;
  width: 16px;
  border: 1px solid
    ${(props) =>
      props.$checked
        ? "var(--Schemes-Brand-color-Primary, #0DA3BA)"
        : "var(--Schemes-Outline-Outline, rgba(0, 38, 58, 0.32))"};
  border-radius: 50%;
  margin-right: 8px;
  position: relative;
  transition: border-color 0.2s ease;

  &::after {
    content: "";
    position: absolute;
    top: 50%;
    left: 50%;
    width: 6.5px;
    height: 6.5px;
    background-color: var(--Schemes-Brand-color-Primary, #0da3ba);
    border-radius: 50%;
    transform: translate(-50%, -50%)
      scale(${(props) => (props.$checked ? 1 : 0)});
    transition: transform 0.2s ease;
  }
`

const Label = styled.span`
  font-size: 14px;
`

interface IProps {
  label: string
  checked?: boolean
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

const CustomRadioButton = ({ label, checked, onChange }: IProps) => {
  return (
    <Wrapper>
      <HiddenRadio checked={!!checked} onChange={onChange} />
      <StyledRadio $checked={!!checked} />
      <Label>{label}</Label>
    </Wrapper>
  )
}

export default CustomRadioButton
